module.exports = __webpack_public_path__ + "static/media/badge-0.43aa9303.png";